// Where each editorial plate is looked at, as a CSS object-position. A frame that
// crops past a fifth of a picture has made a composition decision, and `50% 50%`
// on a portrait poured into a landscape slot is not one — so the value belongs to
// the photograph, not to whichever component happens to be showing it.
// `scripts/check-image-fit.ts` is the gate.
const FOCAL_POINTS: Record<string, string> = {
  "/images/editorial/nb-col-suena.jpg": "50% 58%",
  "/images/editorial/nb-col-cocina.jpg": "50% 55%",
  "/images/editorial/nb-col-jardin.jpg": "50% 52%",
  "/images/editorial/nb-col-tecno.jpg": "50% 55%",
  "/images/editorial/kn-cat-casa-wide.jpg": "45% 47%",
  "/images/editorial/kn-cat-electronica-1.jpg": "50% 59%",
  "/images/editorial/band-bebes.jpg": "76% 54%",
  "/images/editorial/band-belleza.jpg": "74% 58%",
  "/images/editorial/band-calzado.jpg": "70% 58%",
  "/images/editorial/band-deportes.jpg": "75% 54%",
  "/images/editorial/band-electronica.jpg": "77% 38%",
  "/images/editorial/band-hogar.jpg": "72% 56%",
  "/images/editorial/band-juguetes.jpg": "75% 52%",
  "/images/editorial/band-moda.jpg": "74% 48%",
  "/images/editorial/band-perfumes.jpg": "74% 55%",
  "/images/editorial/band-perfumes-tile.jpg": "50% 55%",
  "/images/editorial/band-vehiculo.jpg": "75% 52%",
  "/images/editorial/cartel-01-noche.jpg": "30% 50%",
  "/images/editorial/azzaro-02-humo.jpg": "29% 50%",
  "/images/editorial/rd-cuatro-papel.jpg": "50% 50%",
}

export const focalPoint = (src: unknown): string | undefined => (typeof src === "string" ? FOCAL_POINTS[src.split("?")[0] ?? src] : undefined)
